import { generateCombinedConfigHash as generateCombinedConfigHashBase } from './hash';

export const generateCombinedConfigHash = (userId: string, cloudId: string): number =>
	generateCombinedConfigHashBase(userId, cloudId);
